<template>
  <div class="frequent-questions-center container">
    <div>
      <div class="frequent-questions-center__return">
        <router-link to="/central-de-ajuda">
          <md-icon
            md-src="/static/images/icon-return-purple.svg"
            alt="voltar"
          /> Voltar
        </router-link>
      </div>
    </div>
    <div class="frequent-questions-center__content">
      <h1 class="frequent-questions-center__page-title">
        Perguntas frequentes
      </h1>
      <div class="frequent-questions-center__wrapper">
        <div class="frequent-questions-center__items">
          <ul>
            <li
              v-for="(faq) in faqs"
              :key="faq.ref"
              class="frequent-questions-content"
            >
              <div
                :id="faq.id"
                class="frequent-questions-content__category frequent-questions-center__section"
              >
                {{ faq.category }}
              </div>
              <accordion :content="faq.questions" />
            </li>
          </ul>
          <banner />
        </div>
        <div class="frequent-questions-center__links">
          <ul
            ref="anchorsListQuestions"
            class="frequent-questions-center__links__wrapper"
          >
            <li
              v-for="(faq, index) in faqs"
              :key="index"
              @click="selectedItemMenu($event)"
            >
              <a
                class="frequent-questions-center__anchor"
                :href="'#'+faq.id"
              >
                {{ faq.linkcategory }}
              </a>
            </li>
          </ul>
        </div>
        <PageScrollTop />
      </div>
    </div>
  </div>
</template>

<script>
import PageScrollTop from '@/components/common/PageScrollTop'
import Accordion from '../common/Accordion.vue'
import strings from '@/strings'
import FrequentQuestionsBanner from './FrequentQuestionsBanner'

export default {
  name: 'FrequentQuestionsMainView',
  components: {
    Accordion,
    PageScrollTop,
    banner: FrequentQuestionsBanner
  },
  data: () => {
    return {
      itemSelected: false,
      faqs: strings.frequentQuestions
    }
  },
  computed: {
    sections () {
      return document.getElementsByClassName('frequent-questions-center__section')
    }
  },
  mounted () {
    window.scrollTo(0, 0)

    const firstElementAnchor = this.getFirstElementOfMenu()
    firstElementAnchor.classList.add('frequent-questions-center__anchor--active')
  },
  methods: {
    selectedItemMenu (event) {
      this.target = event.target
      const anchors = this.getElementsOfMenu()
      anchors.forEach(el => {
        el.classList.remove('frequent-questions-center__anchor--active')
      })
      this.target.classList.toggle('frequent-questions-center__anchor--active')
    },
    getElementsOfMenu () {
      return this.$refs.anchorsListQuestions.getElementsByTagName('a')
    },
    getFirstElementOfMenu () {
      return this.getElementsOfMenu()[0]
    }
  }
}
</script>

<style lang="scss">
.frequent-questions-center {
  margin: 60px 0 60px 50px;
  padding: 50px 8%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  gap: 16px;

  font-family: Roboto;
  font-weight: 500;

  &__return {
    font-family: Roboto !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 26px !important;
    color: #7f1a54 !important;
    text-decoration: none !important;
    cursor: pointer !important;
    img {
      color: #7f1a54;
    }
    a {
      color: #7f1a54 !important;
      text-decoration: none !important;
    }
  }

  &:before {
    content: "";
    background-image: url("../../../static/images/icon-lamp.svg");
    background-repeat: no-repeat;
    background-size: 350px;
    background-position: 97% 37%;
    width: 100%;
    position: fixed;
    height: 100%;
    right: 0;
    top: 50%;
    bottom: 0;
    left: 0;
    margin: auto;
    z-index: -1;
  }

  &__content {
    flex-grow: 1;
  }

  &__wrapper {
    flex-shrink: 1;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
  }

  &__items {
    width: calc(70vw - 300px);
  }
  &__links {
    position: relative;

    &__wrapper {
      position: fixed;
      top: 220px;
      li {
        margin: 0 !important;
        /* white-space: nowrap; */
      }
    }
  }
  &__anchor {
    color: #7a7a7a !important;
    text-decoration: none;
    font-size: 14px;
    border-left: 2px solid #dadada;
    padding-left: 20px;
    height: 30px;
    display: flex;
    align-items: center;
    transition: all ease 0.2s;

    &--active {
      color: #7f1a54 !important;
      font-weight: 500;
      border-color: #7f1a54;
    }
  }
  &__section {
    /* margin-bottom: 50px; */
    padding-bottom: 30px;
    padding-top: 90px;
    margin-top: -90px;
    /* border-bottom: 1px solid #d6d6d6; */

    &:last-of-type {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
  &__page-title {
    font-weight: 500;
    font-size: 26px;
    color: #7a7a7a;
    margin-bottom: 40px;
  }
  &__category {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    color: #303030;
    letter-spacing: 0;
    margin-bottom: 25px;
    img {
      margin-right: 10px;
      margin-top: -2px;
    }
    p {
      font-weight: normal;
      font-size: 15px;
      line-height: 18px;
      letter-spacing: -0.321429px;
      display: block;
      margin-top: 15px;
    }
  }
}
.frequent-questions-content {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;

  margin-bottom: 4px;

  &:nth-child(n) {
    margin-bottom: 45px;
  }

  &__category {
    font-size: 18px;
    line-height: 26px;
    color: #7A7A7A;
  }
}
</style>
